import React, { useState, useEffect } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  CLIENT_ID_GMAIL,
  CLIENT_ID_HUBSPOT,
  CLIENT_ID_SALESFORCE,
} from "../../../../constants";
import AuthServ from "../../../Auth/AuthServ/AuthServ";
import { integrationsDescriptions } from "./constants";
import {
  integrationDeleteAccount,
  getIntegrationsLists,
  getIntegrationKey,
  updateIntegrationKey,
  updateZap,
  deleteZap,
  getEmailSignature,
  saveEmailSignature,
} from "../../../../services/api/integrations.api";
import { desynchronizeLinkedinAccount } from "../../../../services/api/linkedin.api";
import { toast } from "react-toastify";
import { Pagination, Permissions } from "../../../../components";
import EmailField from "../../../Leads/common/EmailField/EmailField";
import { FormattedMessage, injectIntl } from "react-intl";

function ConnectionModal(props) {
  const [integrationKey, setIntegrationKey] = useState("");
  const [zaps, setZaps] = useState([]);
  const [zapNames, setZapNames] = useState([]);
  const [editZapNames, setEditZapNames] = useState([]);
  const [confirmDeleteZaps, setConfirmDeleteZaps] = useState([]);
  const [error, setError] = useState("");
  const [signature, setSignature] = useState("");
  let [page, setPage] = useState(1);
  const perPage = 4;

  const updateZapierKey = async () => {
    let { data, statusCode } = await updateIntegrationKey("zapier");
    if (statusCode === 200) {
      setIntegrationKey(data.apiKey);
    } else setError(data.messageTranslated || data.message);
  };

  const saveSignature = async () => {
    let { data, statusCode } = await saveEmailSignature({ signature });
    if (statusCode >= 400) {
      setError(data.messageTranslated || data.message);
    }
    if (statusCode === 200) props.onHide();
  };

  const updateZaps = async (index, property, value) => {
    let updatedZaps = Object.assign([], zaps);
    updatedZaps[index][property] = value;
    await updateZap(updatedZaps[index]);
    setZaps(updatedZaps);
    if (property === "name") {
      let updatedEdit = Object.assign([], editZapNames);
      updatedEdit[index] = false;
      setEditZapNames(updatedEdit);
    }
  };

  const handleConfirmDeleteZap = (index) => {
    let updatedZaps = Object.assign([], confirmDeleteZaps);
    updatedZaps[index] = true;
    setConfirmDeleteZaps(updatedZaps);
  };

  const handleDeleteZap = async (index) => {
    deleteZap(zaps[index]).then(({ data }) => {
      if (data && data.success) {
        setError("");
        let updatedZaps = Object.assign([], zaps);
        updatedZaps.splice(index, 1);
        setZaps(updatedZaps);

        updatedZaps = Object.assign([], editZapNames);
        updatedZaps.splice(index, 1);
        setEditZapNames(updatedZaps);

        updatedZaps = Object.assign([], confirmDeleteZaps);
        updatedZaps.splice(index, 1);
        setConfirmDeleteZaps(updatedZaps);
      } else {
        setError(
          props.intl.formatMessage({
            id: "settings.AnErrorHasOccurredWhileDeletingYourZap",
          })
        );
      }
    });
  };

  const handleChangeZapName = (e, index) => {
    let updatedZapNames = Object.assign([], zapNames);
    updatedZapNames[index] = e.target.value;
    setZapNames(updatedZapNames);
  };

  const handleSetEditZapNames = (index) => {
    let updatedEdit = Object.assign([], editZapNames);
    updatedEdit[index] = true;
    setEditZapNames(updatedEdit);
  };

  const handleConnect = () => {
    props.onHide();
    if (props.integration === "linkedin")
      return window.open("https://www.linkedin.com/feed/?synchro=true");
    props.handleShowApiIntegration();
  };

  const copyToClipboard = () => {
    const cp = document.createElement("textarea");
    cp.value = integrationKey;
    document.body.appendChild(cp);
    cp.select();
    document.execCommand("copy");
    document.body.removeChild(cp);
    toast.success("Key copied!");
  };

  const handleDisconnect = async () => {
    let { data, statusCode } =
      props.integration === "linkedin"
        ? await desynchronizeLinkedinAccount()
        : await integrationDeleteAccount({
            integrationName: props.integration,
          });
    if (statusCode === 200) {
      props.disconnectAccount();
      props.onHide();
    }
  };

  const handleMapping = () => {
    props.onHide();
    props.handleMappingModal();
  };

  const AuthConnect = () => {
    const oauthVariables = {
      clientId: {
        hubspot: CLIENT_ID_HUBSPOT,
        salesforce: CLIENT_ID_SALESFORCE,
        gmail: CLIENT_ID_GMAIL,
      },
      scopes: {
        hubspot: [
          "oauth",
          "crm.objects.contacts.read",
          "crm.objects.contacts.write",
          "crm.schemas.contacts.read",
          "crm.objects.owners.read",
          "crm.schemas.companies.read",
          "crm.schemas.deals.read",
        ],
        salesforce: [],
        gmail: [
          "profile",
          "email",
          "https://www.googleapis.com/auth/gmail.metadata",
          "https://www.googleapis.com/auth/gmail.send\t",
        ],
      },
      oauthUrl: {
        hubspot: "https://app.hubspot.com/oauth/authorize",
        salesforce: "https://login.salesforce.com/services/oauth2/authorize",
        gmail: "https://accounts.google.com/o/oauth2/auth",
      },
    };

    if (props.integration === "zapier") return <div />;
    return ["hubspot", "salesforce", "gmail"].indexOf(props.integration) >
      -1 ? (
      <AuthServ
        clientId={oauthVariables.clientId[props.integration]}
        scopes={oauthVariables.scopes[props.integration]}
        oauthUrl={oauthVariables.oauthUrl[props.integration]}
        type={props.integration}
        responseType={"code"}
        redirectUri={
          window.location.origin + `/socialAuth/${props.integration}/`
        }
        onLogin={props.confirmConnect}
        dim={{ height: 700, width: 800 }}
        inModal={true}
        checkCrmValidity={props.checkCrmValidity}
      />
    ) : (
      <button className={"btn1 ripple-btn"} onClick={handleConnect}>
        <FormattedMessage id={"settings.connectTo"} /> {props.integration}
      </button>
    );
  };

  useEffect(() => {
    if (props.integration === "zapier") {
      getIntegrationKey("zapier").then(({ data }) => {
        if (data && data.message) {
          if (data.message === "You do not belong to an organization")
            setError(
              props.intl.formatMessage({
                id: "settings.youMustBePartOfAnOrganizationInOrderToGetAnApi",
              })
            );
          else if (data.message === "Permission denied")
            if (data.type === "plan")
              setError(
                props.intl.formatMessage({ id: "permissions.upgradePlan" })
              );
            else if (data.type === "organization")
              setError(
                props.intl.formatMessage({ id: "permissions.noAccess" })
              );
          return;
        }
        setIntegrationKey(data.apiKey);
        getIntegrationsLists({ integrationName: "zapier", getAll: true }).then(
          ({ data }) => {
            setZaps(data.lists);
            setZapNames(data.lists.map((list) => list.name));
            setEditZapNames(data.lists.map(() => false));
            setConfirmDeleteZaps(data.lists.map(() => false));
          }
        );
      });
    }
    if (props.integration === "gmail") {
      getEmailSignature().then(({ data, statusCode }) => {
        if (statusCode === 200) {
          setSignature(data && data.signature && data.signature.signature);
        }
      });
    }
  }, []);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      className="fade connect-modal"
      id="connected-tools"
    >
      <Modal.Header closeButton className="border-0">
        <div className="modal-inner-header">
          <div className="profile-img-block">
            <img src={props.imagesrc} alt="" />
          </div>
          <div className="profile-info">
            <p className="username">{props.integration}</p>
            <span className="designation">{props.category}</span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="inner-description">
          <label>Description</label>
          <p>
            <FormattedMessage
              id={integrationsDescriptions[props.integration]}
            />
          </p>
          {props.integration === "zapier" && integrationKey && (
            <div>
              <p>
                <FormattedMessage
                  id={"settings.useThisKeyToConnectKasprThroughZapier"}
                />{" "}
              </p>
              <p>
                <strong> {integrationKey} </strong>
                <i
                  style={{
                    marginLeft: "20px",
                    cursor: "pointer",
                    color: "#797f99",
                  }}
                  onClick={copyToClipboard}
                  className="fas fa-copy"
                >
                  {" "}
                </i>
                <i
                  style={{
                    marginLeft: "20px",
                    cursor: "pointer",
                    color: "#797f99",
                  }}
                  onClick={updateZapierKey}
                  className="fas fa-redo-alt"
                >
                  {" "}
                </i>
              </p>

              <br />
            </div>
          )}
          {props.account && props.integration === "gmail" && (
            <p>
              <p>
                <FormattedMessage
                  id={"settings.editYourEmailSignature"}
                  style={{ marginBottom: "20px" }}
                />
              </p>
              <EmailField
                placeholder="Compose an epic signature..."
                value={signature}
                onChange={setSignature}
              />
            </p>
          )}
          <p>
            {props.account &&
              (props.integration === "zapier"
                ? props.intl.formatMessage({
                    id: "settings.youAreConnectedTo",
                  }) +
                  " " +
                  props.account
                : props.intl.formatMessage(
                    {
                      id: "settings.youAreConnectedUsingThis",
                    },
                    {
                      integration:
                        props.integration[0].toUpperCase() +
                        props.integration.slice(1),
                      account: props.account,
                    }
                  ))}
          </p>
          <div className="user-role-listing">
            {zaps &&
              zaps.length > 0 &&
              zaps
                .slice(perPage * (page - 1), perPage * page)
                .map((zap, index) => {
                  return (
                    <div className="user-role-block">
                      <div className="left-block">
                        <div className={"edit-worklfow-name"}>
                          {!editZapNames[index] ? (
                            <p className="title">
                              <a href={zap.link} target="_blank">
                                {zap.name}
                              </a>
                              <span
                                className={"edit-btn"}
                                style={{ paddingLeft: "10px" }}
                                onClick={(e) => handleSetEditZapNames(index)}
                              >
                                <img
                                  src="/assets/images/ic_edit_g.png"
                                  alt=""
                                />
                              </span>
                            </p>
                          ) : (
                            <div>
                              <input
                                type="text"
                                value={zapNames[index]}
                                onChange={(e) => handleChangeZapName(e, index)}
                                style={{ width: "80%" }}
                              />
                              <button
                                onClick={(e) =>
                                  updateZaps(index, "name", zapNames[index])
                                }
                              >
                                {" "}
                                Ok
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="right-block">
                        <div className="checkbox-wrap">
                          <label>
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                updateZaps(index, "isEnabled", !zap.isEnabled);
                              }}
                              checked={zap.isEnabled}
                              disabled={false}
                            />
                            <span className="checkbox-icon" />
                            <span className="checkbox-text">
                              {" "}
                              <FormattedMessage id={"settings.enabled"} />{" "}
                            </span>
                          </label>
                        </div>
                        <div className="checkbox-wrap">
                          <label>
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                updateZaps(
                                  index,
                                  "autoExport",
                                  !zap.autoExport
                                );
                              }}
                              checked={zap.autoExport}
                              disabled={false}
                            />
                            <span className="checkbox-icon" />
                            <span className="checkbox-text">
                              {" "}
                              <FormattedMessage
                                id={"settings.exportAutomatically"}
                              />{" "}
                            </span>
                          </label>
                        </div>
                        <div className="button-ui delete-account">
                          {confirmDeleteZaps &&
                            confirmDeleteZaps.length > 0 &&
                            (confirmDeleteZaps[index] ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="delete-tooltip">
                                    {" "}
                                    <FormattedMessage
                                      id={"settings.areYouSureYouWantToDelete"}
                                    />{" "}
                                    "{zap.name}" ?
                                  </Tooltip>
                                }
                              >
                                <a
                                  href="#"
                                  className="btn1"
                                  style={{
                                    width: "80px",
                                    height: "30px",
                                    padding: "0px 10px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleDeleteZap(index)}
                                >
                                  <FormattedMessage id={"confirm"} />
                                </a>
                              </OverlayTrigger>
                            ) : (
                              <div
                                style={{
                                  width: "80px",
                                  height: "30px",
                                  padding: "0px 10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src="/assets/images/ic_delete_g.png"
                                  alt=""
                                  style={{ padding: "35%" }}
                                  onClick={() => handleConfirmDeleteZap(index)}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
            <Pagination
              pages={
                Math.floor(zaps && zaps.length / perPage) +
                (zaps && zaps.length % perPage > 0 ? 1 : 0)
              }
              currentPage={page}
              goToPage={setPage}
            />
          </div>
        </div>
        {error && (
          <div className="btn-grp text-center  error  kaspr-form-text-error">
            {error + " "}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0">
        {props.account ? (
          <React.Fragment>
            {/*  <div className="left-ui">
              <a className="connect-btn active">{props.account}</a>
            </div>*/}
            <div className="right-ui">
              {props.integration !== "zapier" && (
                <a
                  href="#"
                  className="btn1 ripple-btn"
                  data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#api-integration-modal"
                  onClick={handleDisconnect}
                >
                  <FormattedMessage id={"settings.disconnect"} />
                </a>
              )}
              {["linkedin", "zapier", "gmail"].indexOf(props.integration) ===
                -1 && (
                <a
                  href="#"
                  style={{ marginLeft: "8px" }}
                  className="btn1 ripple-btn"
                  data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#api-integration-modal"
                  onClick={handleMapping}
                >
                  <FormattedMessage id={"mapping"} />
                </a>
              )}
            </div>
          </React.Fragment>
        ) : (
          <div className="right-ui">
            <a
              href={props.moreInfoLink}
              target="_blank"
              className="text-btn mr14"
            >
              <FormattedMessage id={"info.moreInfo"} />
              <span className="link-icon">
                <img src="/assets/images/link_icon.svg" alt="" />
              </span>
            </a>
            <a>
              {" "}
              {!props.checkMemberPermissions("Sync") ? (
                <Permissions.CallToAction
                  withoutIcon={true}
                  toolTipStyle={{ width: 200 }}
                >
                  <AuthConnect />{" "}
                </Permissions.CallToAction>
              ) : (
                <AuthConnect />
              )}
            </a>
          </div>
        )}
        {props.integration === "zapier" && props.account && (
          <a
            href={props.moreInfoLink}
            target="_blank"
            className="text-btn mr14"
          >
            <FormattedMessage id={"info.moreInfo"} />
            <span className="link-icon">
              <img src="/assets/images/link_icon.svg" alt="" />
            </span>
          </a>
        )}
        {props.account && props.integration === "gmail" && (
          <a
            href="#"
            style={{ marginLeft: "8px" }}
            className="btn1 ripple-btn"
            data-dismiss="modal"
            data-toggle="modal"
            onClick={saveSignature}
          >
            <FormattedMessage id={"settings.saveSignature"} />
          </a>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default injectIntl(ConnectionModal);
